(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('showcaseApp')
        .constant('VERSION', "4.13.3")
        .constant('DEBUG_INFO_ENABLED', false)
        .constant('ADMIN_SYSTEM_ID', 0)
;
})();
